import { SxProps, Theme } from "@mui/material/styles";
import theme from "src/themes";
import GoBadge from "./GoBadge";

const KviBadge = ({ sx }: { sx?: SxProps<Theme> }) => {
    const { kvi } = theme.palette.badge;
    return (
        <GoBadge
            label="KVI"
            textColor={kvi.text}
            backgroundColor={kvi.background}
            borderColor={kvi.border}
            sx={sx}
        />
    );
};

export default KviBadge;
